import React, { createContext, useContext, useState } from "react";

const DarkModeContext = createContext();

export const useDarkMode = () => useContext(DarkModeContext);

export const DarkModeProvider = ({ children }) => {
  const [isDarkModeContext, setIsDarkMode] = useState(false);
  const [isProviderPopup, setIsProviderPopup] = useState(false);


  return (
    <DarkModeContext.Provider value={{ isDarkModeContext, setIsDarkMode, isProviderPopup,  setIsProviderPopup}}>
      {children}
    </DarkModeContext.Provider>
  );
};


